import { withState } from 'recompose';

export default withState('validationError', 'updateValidationError', {
  email: null,
  firstName: null,
  lastName: null,
  phone: null,
  companyName: null
});
